// removed by extract-text-webpack-plugin
module.exports = {"table":"_2tDSapkTjptmMssAzeUuDK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisWrapUnwrapBalances.scss
// module id = 1291
// module chunks = 0